// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"230":"0bf2e2c9","369":"3ca43b35","389":"f3c4e7b1"}[chunkId] + ".chunk.js";
};